import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StrategicGoal } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-strategic-goal-link',
    templateUrl: './strategic-goal-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class StrategicGoalLinkComponent {
    @Input() public item: StrategicGoal;
    public permissionList = permissionList;
}
